import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import {FieldArray} from 'formik';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {InputTypeahead} from '../FieldInputTypeahead';
import Empty from '../Empty';
import ContactItem from './ContactItem';
import * as actions from '../../actions/findContacts';
import styles from './styles.module.scss';

const FieldFindContacts = ({
                             formik,
                             name,
                             customContainerStyles = '',
                             customListStyles = '',
                             customLabel,
                             showEmptyMessage = true,
                           }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [inputValue, setInputValue] = useState('');

  const findContact = (input) => dispatch(actions.findContacts(input));

  const getContactDetails = (contact) => {
    if (!contact) return '';
    const {firstName, lastName, phone, email} = contact;
    const fullName = [firstName, lastName].filter(Boolean).join(' ');
    return {
      fullName: fullName || '-',
      phone: phone || '-',
      email: email || '-'
    };
  };

  return (
    <div className={classNames(styles.container, customContainerStyles)}>
      <FieldArray name={name}>
        {({replace, remove}) => {
          const currentContacts = formik.values[name] || [];

          const contactNotInList = (contact) => {
            return !currentContacts.some(c => c.contactID === contact.contactID);
          };

          const handleAdd = ([value]) => {
            if (!value) return;
            if (contactNotInList(value)) {
              replace(0, value);
              formik.setTouched({[name]: true});
            }
            setInputValue('');
          };

          return (
            <>
              <InputTypeahead
                id={`inputValue`}
                value={inputValue}
                isLoading={false}
                labelKey={option => `${option.firstName} ${option.lastName} ${option.phone} ${option.email}`}
                onChange={handleAdd}
                onInputChange={setInputValue}
                renderMenuItemChildren={option => <ContactItem {...option} />}
                handleFindItem={findContact}
                placeholder={''}
                label={
                  <div className={styles.label}>
                    {customLabel || intl.formatMessage({
                      id: 'typeahead-contact-label',
                      defaultMessage: 'Search contact'
                    })}
                  </div>
                }
              />
              <div className={classNames(styles.list, customListStyles)}>
                {currentContacts.length > 0 ? (
                    currentContacts.map((contact, index) => (
                      <div key={index} className={styles.selectedItem}>
                        <div className={styles.info}>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/User_primary.svg')} alt="i"/>
                            <span>{getContactDetails(contact).fullName}</span>
                          </div>
                          <div/>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/Phone_primary.svg')} alt="i"/>
                            <span>{getContactDetails(contact).phone}</span>
                          </div>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/Email_primary.svg')} alt="i"/>
                            <span>{getContactDetails(contact).email}</span>
                          </div>
                        </div>
                        <img
                          src={'../../../media/common/Delete_red.svg'}
                          alt="remove"
                          onClick={() => remove(index)}
                          className={'h-20px ml-4 cursor-pointer'}
                        />
                      </div>
                    )))
                  : (showEmptyMessage &&
                    <Empty message={intl.formatMessage({id: 'typeahead-contact-no-data', defaultMessage: 'No data'})}
                    />
                  )
                }
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default FieldFindContacts;
